import styled, { css } from 'styled-components';
import { FONT_TYPES, Heading, mediaMixin, typographyMixin } from '@zillow/constellation';

type fontTypeType = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body';
type smallerFontType = 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'bodySmallHeading' | 'bodySmall';

const ONE_SMALLER_FONT_TYPE: Record<fontTypeType, smallerFontType> = {
    [FONT_TYPES.h1]: FONT_TYPES.h2,
    [FONT_TYPES.h2]: FONT_TYPES.h3,
    [FONT_TYPES.h3]: FONT_TYPES.h4,
    [FONT_TYPES.h4]: FONT_TYPES.h5,
    [FONT_TYPES.h5]: FONT_TYPES.h6,
    [FONT_TYPES.h6]: FONT_TYPES.bodySmallHeading,
    [FONT_TYPES.body]: FONT_TYPES.bodySmall
};

/**
 * Text and Header's responsiveness to screen width was deprecated in Constellation 8.0.0.
 * ResponsiveHeading immitates the previously responsive typography styles and can be
 * used with the same props as Heading.
 *
 * Required params:
 * - level (Constellation): A string or number representing the heading level
 * - fontType (custom): A string representing the html heading styles on desktop screen sizes
 *
 * Note: the styled-components polymorphic "as" prop will break this component
 */

const ResponsiveHeading = styled(Heading)<{ fontType: fontTypeType }>`
    ${({ fontType, ...props }) =>
        typographyMixin({ fontType: ONE_SMALLER_FONT_TYPE[fontType as fontTypeType], ...props })}

    ${mediaMixin(
        'lg',
        css`
            ${({ fontType, ...props }: { fontType: fontTypeType }) =>
                typographyMixin({ fontType: FONT_TYPES[fontType], ...props })}
        `
    )};
`;

export default ResponsiveHeading;
